<template>
	<div class="beneficialOwnerBox flex flex_column">
		<div class="flex flex_end">
			<md-button class="md-simple md-just-icon actionIconBtn" @click="$emit('edit')">
				<i class="fa fa-pencil"/>
			</md-button>
			<md-button class="md-simple md-just-icon actionIconBtn" @click="$emit('delete')">
				<i class="fa fa-trash"/>
			</md-button>
		</div>
		<div class="margin_horizontal margin_bottom">
			<table class="ownerInfoTable">
				<tr>
					<td><span>{{ $t("common.name") }}: </span></td>
					<td><span>{{ form.firstName }} {{ form.lastName }}</span></td>
				</tr>
				<tr>
					<td><span>{{ $t("common.dateOfBirth") }}: </span></td>
					<td><span class="font_bold">{{ $t(form.birthday) }}</span></td>
				</tr>
				<tr>
					<td><span>{{ $t("common.placeOfBirth") }}: </span></td>
					<td><span class="font_bold">{{ $t(form.birthplace) }}</span></td>
				</tr>
				<tr>
					<td><span>{{ $t("common.nationality") }}: </span></td>
					<td><span class="font_bold">{{ $t(form.nationality) }}</span></td>
				</tr>
				<tr>
					<td><span>{{ $t("common.address") }}: </span></td>
					<td><span class="font_bold">{{ $t(form.address) }}</span></td>
				</tr>
			</table>
		</div>
	</div>
</template>

<script>
import {enumDef} from "src/common/enumDefs";
import {formatAsAddress, formatAsCountryName, formatAsLocalizedDate} from "@/common/format";

export default {
	props: {
		data: { type: Object },
	},
	data() {
		return {
			enumDef: enumDef,
			form: {
				firstName: "",
				lastName: "",
				birthday: "",
				birthplace: "",
				address: ""
			}
		};
	},
	created() {
		this.updateForm();
	},
	methods: {
		updateForm() {
			this.form = {
				...this.data,
				birthday: formatAsLocalizedDate(this.data.birthday, { valueFormat: "dd.MM.yyyy" }),
				nationality: formatAsCountryName(this.data.nationality),
				address: formatAsAddress(
					this.data.residentialAddress.street,
					this.data.residentialAddress.houseNumber,
					this.data.residentialAddress.postCode,
					this.data.residentialAddress.city,
					this.data.residentialAddress.country
				)
			}
		},
	},
	watch: {
		data() {
			this.updateForm();
		}
	}
};
</script>

<style lang="scss" scoped>
	@import "@/assets/scss/base_variables.scss";

	.beneficialOwnerBox {
		background-color: $gray-very-light;
	}

	.ownerInfoTable {
		tr > td,th {
			min-width: 100px;
			vertical-align: top;
		}

		tr > td:nth-child(1) {
			text-align: right;
			padding-right: 0.5rem;
		}

		tr > td:nth-child(2) {
			font-weight: $font-weight-bold;
		}
	}

	.actionIconBtn {
		min-width: 25px;
		width: 25px;
		min-height: 25px;
		height: 25px;
		margin-right: 5px;
	}
</style>